export const environment = {
  production: true,
  envName: 'stage',
  // redirectUrl: 'https://sso1beta.snapon.com/Account/Login?ReturnUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fclient_id%3DMobileApp.js%26redirect_uri%3Dhttps%253A%252F%252Fstage2-rims.inavista.com%252Fauth%26response_type%3Did_token%2520token%26scope%3Dopenid%2520profile%2520Roles%26state%3D16414008400430.ruvtjl5vfu%26nonce%3D16414008400430.usnkl95geh',
  redirectUrl:
    'https://sso1beta.snapon.com/connect/authorize?client_id=MobileAppStaging.js&redirect_uri=https://stage-rims.inavista.com/auth&response_type=id_token%20token&scope=openid%20profile%20Roles&state=16742019005960.zhfk0ghp5ae&nonce=16742019005960.ropusfjkqn',
  loginUrl: 'https://stage.auth.inavista.com/',
  apiUrl: 'https://stage.api.biznesflow.com/api',
  loginAppUrl: 'https://stage.auth.inavista.com/',
  GetReolliAccessToken: 'https://stage.api.biznesflow.com/api/IssueTracking/GetReolliAccessToken?tenantId=1',
  IssueTrackingIframeBaseUrl: 'https://stage.issue.reolli.com',
  webAuthUrl: '',
  notificationHubUrl: 'https://stage.api.biznesflow.com/notificationHub',
  trainingAppUrl: 'https://trainingportal.inavista.com/project/4',
};
